import { render, staticRenderFns } from "./doctorTeam.vue?vue&type=template&id=2c30fc6e&scoped=true&"
import script from "./doctorTeam.vue?vue&type=script&lang=js&"
export * from "./doctorTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30fc6e",
  null
  
)

export default component.exports